import store from 'store2';
import { authConstants } from './constants';

const initialState = {
  isLoadInner: false,
  isLoad: false,
  otpLoad: false,
  message: null,
  otpMessage: null,
  otpTime: null,
  loadErr: null,
  otpSubmitLoad: false,
  user: store.get('user') || null,
  sessionExpired: false,
  loadErrRegister: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    // Loading
    case authConstants.LOAD:
      return {
        ...state,
        isLoad: true,
        loadErr: null,
      };
    case authConstants.LOAD_SUCCESS:
      return {
        ...state,
        isLoad: false,
        loadErr: null,
        message: action.message,
      };
    case authConstants.LOAD_FAIL:
      return {
        ...state,
        isLoad: true,
        loadErr: action.error,
        message: null,
      };

    case authConstants.MFA_VERIFY_LOAD:
      return {
        ...state,
        otpSubmitLoad: true,
        loadErr: null,
      };
    case authConstants.MFA_VERIFY_SUCCESS:
      return {
        ...state,
        otpSubmitLoad: false,
        loadErr: null,
        message: action.message,
      };
    case authConstants.MFA_VERIFY_FAIL:
      return {
        ...state,
        otpSubmitLoad: false,
        loadErr: action.error,
        message: null,
      };

    case authConstants.CLEAR_MESSAGE:
      return {
        ...state,
        isLoad: false,
        loadErr: null,
        message: null,
      };
    case authConstants.ASSIGN_USER:
      return {
        ...state,
        user: { ...state.user, ...action.user },
      };
    // Reset reducer

    case authConstants.FLUSH:
      return {
        isLoadInner: false,
        isLoad: false,
        message: null,
        loadErr: null,
        user: null,
        sessionExpired: false,
        loadErrRegister: null,
      };
    case authConstants.FLUSH_TIMER:
      return {
        ...state,
        otpTime: null,
      };
    case authConstants.SESSION_EXPIRED:
      return {
        ...state,
        sessionExpired: true,
      };
    // Default
    default:
      return state;
  }
}
